export enum WishlistEventType {
	WISHLIST_SERVICE_READY = 'WishlistServiceReady',
	FAVOURITE_ADDED = 'FavouriteAdded',
	FAVOURITE_REMOVED = 'FavouriteRemoved',
	WISHLIST_ORDER_CHANGED = 'WishlistOrderChanged',
}
